export type AppParam = {
  id: number;
  name: string;
  textResourceKey: string;
  description: string;
  descriptionTextResourceKey: string;
  onlyTenantAdminCanChangeValue: boolean;
  stringValue: string;
  value: any;

  defaultValue: string;
  overridenAtTenantLevel: boolean;
  overridenAtCountryLevel: boolean;
  typeId: number;

  groupId: number;
  groupName: string;
  groupTextResourceKey: string;
};

export enum AppParamTypesEnum {
  Integer = 1,
  Boolean = 2,
  String = 3,
  Decimal = 4,
  JSON = 5,
  DateTime = 6
}

export type AppParamPossibleValues = {
  appParamId: number;
  possibleValues: AppParamPossibleValue[];
}

export type AppParamPossibleValue = {
  value: any;
  stringValue: string;
  name: string;
  textResourceKey: string;
}

export enum AppParamsEnum {
  ApiGlobalTop = 1,
  ExportGlobalTop = 2,
  ApplyRatePlansToAllAccomodationUnitTypes = 5,
  TenantWorkingCurrency = 6,
  TenantFormalCurrency = 16,
  EnableMultiCurrencyInvoices = 14,
  ReservationDefaultHoldDuration = 9,
  ReservationInitialState = 10,
  ReservationFormBlankPriceOption = 81,
  ReservationShowRatePlanPopup = 83,
  ShowOwnerPriceOffset = 85,
  ReservationShowHolderInfo = 86,
  ReservationShowGuestInfo = 87,
  TenantLineItemTemplate = 94,
  CheckOutOnEVisitorState = 95,
  CheckInEVisitorState = 96,
  StatusToCheckedInState = 98,
  ReservationTenantUsesServiceTypes = 99,
  TenantLineItemDistributionStrategy = 104,
  TenantIgnoreDocTypePrefixOnAccommodation = 106,
  TenantUnitLineRenderLineOne = 107,
  TenantUnitLineRenderLineTwo = 108,
  ReservationHideArrivalDeparture = 110,
  ReservationHideDeposit = 111,
  ReservationHideDiscount = 112,
  ReservationEVisitorCollapseExpandHideFacilityInfo = 113,
  TenantUsesPropertiesAsBusinessUnits = 116,

  RoutePrepaymentsForOwnNameAndOtherInvoice = 119,
  RouteInvoicesForOwnNameAndOtherInvoice = 239,

  ReservationEVisitorCalculateCTWithEVisitorDates = 120,
  ShowRegistrationFormButton = 121,
  ShowCopyGuestsButton = 122,
  ShowAOSPeriodColumn = 123,
  TenantGeneratesOwnersInvoices = 125,
  TenantGeneratesDeliveryNotes = 126,
  TenantUsesOfficialRates = 127,
  AllowOfficialRatesInWorkingCurrency = 228,
  OfficialRatesUseSeasonNames = 229,
  OfficialRatesDateFromDefaultsToPlus1Day = 231,
  TenantUsesAvailabilityBlockerCalculations = 241,

  TenantUsesLazyLoadedCalendar = 244,

  DisableCustomAddOnServiceLineItems = 249,
  TenantShowAddOnServiceDiscount = 251,

  TenantExportsSEPA = 252,
  TenantExportsOwnersInvoices = 253,
  TenantExportsAgencyCommissionInvoices = 254,
  TenantExportsGuestInvoices = 255,

  TenantHasAgencyCommissionForPrepayments = 256,
  TenantOfficialRateDefaultCurrency = 258,
  ShowUnpaidPrepaymentsModal = 259,
  TenantUsesInstalments = 260,
  TenantUsesBookingFees = 264,

  HistoricCurrencyId = 266,
  HistoricCurrencyConversionRate = 267,

  TenantUsesAvailabilityChangelog = 271,
  EnableOwnersPartAOSOwnerInvoices = 277,
  ChildrenAffectPAXRatePlanSelection = 279,
  ShowOwnersReservationOnDashboard = 280,

  AsyncBulkInvoiceGeneration = 287,

  CalendarOBLOSCategoriesApplicationAllowed = 288,
  CalendarRelatedRatesPriceUpdateTypeDefault = 289,
  CalendarRelatedRatesRestrictionsUpdateTypeDefault = 290,
  BusinessUnitShowCadastralInfo = 291,
  BusinessUnitShowDates = 292,
  CashRegisterEnable = 293,

  AutomaticRelatedAdvanceInvoiceCancellingDefault = 294,

  TenantCanEditPAXCategories = 297,
  TenantAutomaticPAXCategoriesAreIndividual = 298,
  TenantCanEditLOSCategories = 299,
  TenantOBRsUseRelativePricing = 300,

  ReservationsGridFiltersByDate = 301,

  CardTypeRequiredForCardPaymentMeans = 303,

  Allow0InputPriceForOfficialRate = 305,

  AsyncRatePlanAvailabiltyUpdateThresholdSize = 307,

  TenantUsesAgencyFees = 312,

  TenantUsesSelfCheckIn = 315,
  AutomaticallyChangeReservationStatusToConfirmed = 316,

  StayLineItemsReverseChargeExemptionReason = 379,
  TenantDoesNotPayVatExemptionReason = 380,
  StayLineItemsExemptionReason = 381, 
  CancellationExemptionReason = 382,
  ExchangeRateDifferenceExemptionReason = 383,
  CityTaxExemptionReason = 384,
  AddOnServiceCanBeRelative = 390,
  MessageSchedulingSleepTimePeriod = 391,

  TenantUsesBookingEngineBookingConfirmation = 392
}
